// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Comment Lines, removed unused types
// MODIFIED DATE: 25-09-2025

import ClosedLoanReportActionTypes from './closed-loan-report.types';

/****************  GET CLOSED LOAN DETAILS LIST START *********************** */
export const getClosedLoanDetailsDetailsStart = (getData: any) => ({
	type: ClosedLoanReportActionTypes.GET_CLOSED_LOAN_DETAILS_LIST_START,
	payload: getData,
});

export const getClosedLoanDetailsDetailsSuccess = (successData: any) => ({
	type: ClosedLoanReportActionTypes.GET_CLOSED_LOAN_DETAILS_LIST_SUCCESS,
	payload: successData,
});

export const getClosedLoanDetailsDetailsFailure = (failureData: any) => ({
	type: ClosedLoanReportActionTypes.GET_CLOSED_LOAN_DETAILS_LIST_FAILURE,
	payload: failureData,
});

export const getClosedLoanDetailsDetailsResponseResetStart = () => ({
	type: ClosedLoanReportActionTypes.GET_CLOSED_LOAN_DETAILS_LIST_RESPONSE_RESET,
});

export const getClosedLoanDetailsDetailsResponseChanged = () => ({
	type: ClosedLoanReportActionTypes.GET_CLOSED_LOAN_DETAILS_LIST_RESPONSE_CHANGED,
});
/****************  GET CLOSED LOAN DETAILS LIST END *********************** */
